import { BrowserModule } from '@angular/platform-browser';
import { NgModule, Injectable, Pipe, PipeTransform } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { HttpModule } from '@angular/http';
import { RouterModule, Routes } from '@angular/router';

import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { NgbdDatepickerPopup } from './bootstrap/datepicker-popup';

import { LocalStorageModule } from 'angular-2-local-storage';

import { AppComponent } from './app.component';
import { ConsorcioDetailComponent } from './components/consorcio-detail/consorcio-detail.component';

import { ConsorciosService } from './services/consorcios.service';
import { MonedaService } from './services/moneda.service';
import { SucursalService } from './services/sucursal.service';
import { CatalogoCobroService } from './services/catalogo-cobro.service';
import { CatalogoServiciosService } from './services/catalogo-servicios.service';
import { UtilitiesService } from './services/utilities.service';
import { ArticuloService } from './services/articulo.service';
import { TipoService } from './services/tipo.service';
import { CategoriaService } from './services/categoria.service';
import { SubcategoriaService } from './services/subcategoria.service';
import { SocioService } from './services/socio.service';
import { BodegaService } from './services/bodega.service';
import { DocumentoEntradaService } from './services/documento-entrada.service';
import { DocumentoSalidaService } from './services/documento-salida.service';
import { DocumentoDetalleEntradaService } from './services/documento-detalle-entrada.service';
import { DocumentoDetalleSalidaService } from './services/documento-detalle-salida.service';
import { UsuarioService } from './services/usuario.service';
import { UsuarioSucursalService } from './services/usuario-sucursal.service';
import { ServicioEspecialService } from './services/servicio-especial.service';
import { IngresoService } from './services/ingreso.service';
import { SubirDocumentosService } from './services/subir-documentos.service';
import { SeguridadService } from './services/seguridad.service';
import { SubirImagenesService } from './services/subir-imagenes.service';
import { ReporteInventarioService } from './services/reporte-inventario.service';
import { SubirArticulosService } from './services/subir-articulos.service';
import { FormulaCobroService } from './services/formula-cobro.service';
import { ZonaService } from './services/zona.service';


import { HomeComponent } from './components/home/home.component';
import { IngresoComponent } from './components/ingreso/ingreso.component';
import { PageNotFoundComponent } from './components/page-not-found/page-not-found.component';
import { ConsorcioMantenimientoComponent } from './components/consorcio-mantenimiento/consorcio-mantenimiento.component';
import { SucursalDetailComponent } from './components/sucursal-detail/sucursal-detail.component';
import { SucursalMantenimientoComponent } from './components/sucursal-mantenimiento/sucursal-mantenimiento.component';
import { CatalogoCobroListComponent } from './components/catalogo-cobro-list/catalogo-cobro-list.component';
import { CatalogoCobroMantenimientoComponent } from './components/catalogo-cobro-mantenimiento/catalogo-cobro-mantenimiento.component';
import { CatalogoServiciosListComponent } from './components/catalogo-servicios-list/catalogo-servicios-list.component';
import { CatalogoServiciosMantenimientoComponent } from './components/catalogo-servicios-mantenimiento/catalogo-servicios-mantenimiento.component';
import { ArticuloListComponent } from './components/articulo-list/articulo-list.component';
import { ArticuloMatenimientoComponent } from './components/articulo-matenimiento/articulo-matenimiento.component';
import { CategoriaArticuloMantenimientoComponent } from './components/categoria-articulo-mantenimiento/categoria-articulo-mantenimiento.component';
import { ArticuloSubcategoriaComponent } from './components/articulo-subcategoria/articulo-subcategoria.component';
import { CategoriaArticuloListComponent } from './components/categoria-articulo-list/categoria-articulo-list.component';
import { SubcategoriaArticuloListComponent } from './components/subcategoria-articulo-list/subcategoria-articulo-list.component';
import { TipoUnidadCobroComponent } from './components/tipo-unidad-cobro/tipo-unidad-cobro.component';
import { SocioListComponent } from './components/socio-list/socio-list.component';
import { SocioMantenimientoComponent } from './components/socio-mantenimiento/socio-mantenimiento.component';
import { BodegaListComponent } from './components/bodega-list/bodega-list.component';
import { BodegaMantenimientoComponent } from './components/bodega-mantenimiento/bodega-mantenimiento.component';
import { SubcategoriaArticuloMantenimientoComponent } from './components/subcategoria-articulo-mantenimiento/subcategoria-articulo-mantenimiento.component';
import { DocumentoEntradaListComponent } from './components/documento-entrada-list/documento-entrada-list.component';
import { DocumentoSalidaListComponent } from './components/documento-salida-list/documento-salida-list.component';
import { DocumentoEntradaMantenimientoComponent } from './components/documento-entrada-mantenimiento/documento-entrada-mantenimiento.component';
import { DocumentoSalidaMantenimientoComponent } from './components/documento-salida-mantenimiento/documento-salida-mantenimiento.component';
import { DocumentoEntradaDetalleListComponent } from './components/documento-entrada-detalle-list/documento-entrada-detalle-list.component';
import { DocumentoSalidaDetalleListComponent } from './components/documento-salida-detalle-list/documento-salida-detalle-list.component';
import { DocumentoEntradaDetalleMantenimientoComponent } from './components/documento-entrada-detalle-mantenimiento/documento-entrada-detalle-mantenimiento.component';
import { DocumentoSalidaDetalleMantenimientoComponent } from './components/documento-salida-detalle-mantenimiento/documento-salida-detalle-mantenimiento.component';

import { TestingComponent } from './services/testing/testing.component';
import { UsuarioListComponent } from './components/usuario-list/usuario-list.component';
import { UsuarioMantenimientoComponent } from './components/usuario-mantenimiento/usuario-mantenimiento.component';
import { ServicioEspecialListComponent } from './components/servicio-especial-list/servicio-especial-list.component';
import { ServicioEspecialMantenimientoComponent } from './components/servicio-especial-mantenimiento/servicio-especial-mantenimiento.component';
import { ReporteInventarioComponent } from './components/reporte-inventario/reporte-inventario.component';
import { WaitProcessingComponent } from './components/wait-processing/wait-processing.component';
import { ArticuloBuscarComponent } from './components/articulo-buscar/articulo-buscar.component';
import { DocumentoSalidaCabeceraComponent } from './components/documento-salida-cabecera/documento-salida-cabecera.component';
import { DocumentoSalidaDetalleComponent } from './components/documento-salida-detalle/documento-salida-detalle.component';
import { DocumentoGaleriaComponent } from './components/documento-galeria/documento-galeria.component';
import { ReporteInventarioSeriesComponent } from './components/reporte-inventario-series/reporte-inventario-series.component';
import { MenuPrincipalComponent } from './components/menu-principal/menu-principal.component';
import { UsuarioPermisoComponent } from './components/usuario-permiso/usuario-permiso.component';
import { ReporteLoteComponent } from './components/reporte-lote/reporte-lote.component';
import { ReporteListaEmpaqueComponent } from './components/reporte-lista-empaque/reporte-lista-empaque.component';
import { DocumentoArchivoSubirResultadoComponent } from './components/documento-archivo-subir-resultado/documento-archivo-subir-resultado.component';
import { ReporteArticulosSupremeComponent } from './components/reporte-articulos-supreme/reporte-articulos-supreme.component';
import { ReporteMovimientosSupremeComponent } from './components/reporte-movimientos-supreme/reporte-movimientos-supreme.component';
import { ReporteRecepcionesSupremeComponent } from './components/reporte-recepciones-supreme/reporte-recepciones-supreme.component';
import { TiposComponent } from './components/tipos/tipos.component';
import { ServicioEspecialDocumentoComponent } from './components/servicio-especial-documento/servicio-especial-documento.component';
import { ReporteArticulosComponent } from './components/reporte-articulos/reporte-articulos.component';
import { ProformaComponent } from './components/proforma/proforma.component';
import { TipoFormulaCobroComponent } from './components/tipo-formula-cobro/tipo-formula-cobro.component';
import { ReporteRecepcionesDiariasComponent } from './components/reporte-recepciones-diarias/reporte-recepciones-diarias.component';
import { IlgReporteInventarioComponent } from './components/ilg-reporte-inventario/ilg-reporte-inventario.component';
import { ReportePosicionDiariaComponent } from './components/reporte-posicion-diaria/reporte-posicion-diaria.component';
import { ReporteListaEmpaqueTplComponent } from './components/reporte-lista-empaque-tpl/reporte-lista-empaque-tpl.component';
import { DatePipe } from '@angular/common';


@Pipe({
  name: 'searchfilter'
})

@Injectable()
export class SearchFilterPipe implements PipeTransform {
  transform(items: any[], value: string): any[] {
    if (!items) return [];
    if (value === "") return items;
    return items.filter(it => JSON.stringify(it).toLowerCase().indexOf(value.toLowerCase()) !== -1);
  }
}

@Pipe({
  name: 'sum'
})
export class SumPipe implements PipeTransform {
  transform(items: any[], attr: string): any {
    return items.reduce((a, b) => a[attr] + b[attr], 0);
  }
}



const appRoutes: Routes = [

  { path: 'inicio', component: HomeComponent },
  { path: 'consorcios', component: ConsorcioDetailComponent },
  { path: 'sucursales', component: SucursalDetailComponent },
  /*{ path: 'catalogo-cobro', component: CatalogoCobroListComponent },  */
  { path: 'catalogo-servicios', component: CatalogoServiciosListComponent },
  { path: 'catalogo-articulos', component: ArticuloListComponent },
  { path: 'catalogo-categoria-articulos', component: CategoriaArticuloListComponent },
  { path: 'catalogo-subcategoria-articulos', component: SubcategoriaArticuloListComponent },
  { path: 'socios', component: SocioListComponent },
  { path: 'bodegas', component: BodegaListComponent },
  { path: 'tipos', component: TiposComponent },
  { path: 'documentos-entrada', component: DocumentoEntradaListComponent },
  { path: 'documentos-salida', component: DocumentoSalidaListComponent },
  { path: 'test', component: TestingComponent },
  { path: 'servicio-especial', component: ServicioEspecialListComponent },
  { path: 'usuarios', component: UsuarioListComponent },
  { path: 'reporte-inventario', component: ReporteInventarioComponent },
  { path: 'documento-galeria', component: DocumentoGaleriaComponent },
  { path: 'reporte-series', component: ReporteInventarioSeriesComponent },
  { path: 'usuario-permiso', component: UsuarioPermisoComponent },
  { path: 'reporte-lote', component: ReporteLoteComponent },
  { path: 'reporte-lista-empaque', component: ReporteListaEmpaqueComponent },
  { path: 'reporte-lista-empaque-tpl', component: ReporteListaEmpaqueTplComponent },
  { path: 'reporte-articulos-supreme', component: ReporteArticulosSupremeComponent },
  { path: 'reporte-movimientos-supreme', component: ReporteMovimientosSupremeComponent },
  { path: 'reporte-recepciones-supreme', component: ReporteRecepcionesSupremeComponent },
  { path: 'reporte-recepciones-diarias', component: ReporteRecepcionesDiariasComponent },
  { path: 'reporte-articulos', component: ReporteArticulosComponent },
  { path: 'reporte-posiciones-diarias', component: ReportePosicionDiariaComponent },
  { path: 'ilg-reporte-inventario', component: IlgReporteInventarioComponent },
  { path: 'proforma', component: ProformaComponent },
  { path: '', component: IngresoComponent },
  { path: 'home', component: HomeComponent },
  { path: '**', component: PageNotFoundComponent }

];


@NgModule({
  declarations: [
    AppComponent, SearchFilterPipe, SumPipe, ConsorcioDetailComponent, HomeComponent, PageNotFoundComponent,
    ConsorcioMantenimientoComponent, NgbdDatepickerPopup, SucursalDetailComponent, SucursalMantenimientoComponent,
    CatalogoCobroListComponent, CatalogoCobroMantenimientoComponent, CatalogoServiciosListComponent,
    CatalogoServiciosMantenimientoComponent, ArticuloListComponent, ArticuloMatenimientoComponent,
    CategoriaArticuloMantenimientoComponent, ArticuloSubcategoriaComponent, CategoriaArticuloListComponent,
    SubcategoriaArticuloListComponent, TipoUnidadCobroComponent, SocioListComponent, SocioMantenimientoComponent,
    BodegaListComponent, BodegaMantenimientoComponent, SubcategoriaArticuloMantenimientoComponent, DocumentoEntradaListComponent,
    DocumentoSalidaListComponent, DocumentoEntradaMantenimientoComponent, DocumentoSalidaMantenimientoComponent,
    DocumentoEntradaDetalleListComponent, DocumentoSalidaDetalleListComponent, DocumentoEntradaDetalleMantenimientoComponent,
    DocumentoSalidaDetalleMantenimientoComponent, TestingComponent, UsuarioListComponent, UsuarioMantenimientoComponent,
    IngresoComponent, ServicioEspecialListComponent, ServicioEspecialMantenimientoComponent, ReporteInventarioComponent,
    WaitProcessingComponent, ArticuloBuscarComponent, DocumentoSalidaCabeceraComponent, DocumentoSalidaDetalleComponent,
    DocumentoGaleriaComponent, ReporteInventarioSeriesComponent, MenuPrincipalComponent, UsuarioPermisoComponent, ReporteLoteComponent,
    ReporteListaEmpaqueComponent, DocumentoArchivoSubirResultadoComponent, ReporteArticulosSupremeComponent, ReporteMovimientosSupremeComponent,
    ReporteRecepcionesSupremeComponent, TiposComponent, ServicioEspecialDocumentoComponent, ReporteArticulosComponent,
    ProformaComponent, TipoFormulaCobroComponent, ReporteRecepcionesDiariasComponent, IlgReporteInventarioComponent, ReportePosicionDiariaComponent, ReporteListaEmpaqueTplComponent
  ],
  imports: [
    BrowserModule,
    FormsModule,
    HttpModule,
    RouterModule.forRoot(appRoutes),
    NgbModule.forRoot(),
    LocalStorageModule.withConfig({
      prefix: 'my-app',
      storageType: 'localStorage'
    })
  ],
  providers: [ConsorciosService, MonedaService,
    SucursalService, CatalogoCobroService,
    CatalogoServiciosService, UtilitiesService,
    ArticuloService, TipoService,
    CategoriaService, SubcategoriaService,
    SocioService, BodegaService,
    DocumentoEntradaService, DocumentoSalidaService,
    DocumentoDetalleEntradaService, DocumentoDetalleSalidaService,
    UsuarioService, UsuarioSucursalService,
    ServicioEspecialService, IngresoService,
    SubirDocumentosService, SeguridadService,
    SubirImagenesService, ReporteInventarioService,
    SubirArticulosService, FormulaCobroService,
    ZonaService, DatePipe
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }





// WEBPACK FOOTER //
// D:/Proyectos/tpl viejo prueba/eflowTPL/src/app/app.module.ts